import { createSelector } from 'reselect'

const getState = state => state.ArchivedInvitations

const getFetchInvitationsRequest = state =>
  getState(state).fetchInvitationsRequest

const getRemoveInvitationRequests = state =>
  getState(state).removeInvitationRequests

const getRemoveInvitationRequest = (state, id) =>
  getRemoveInvitationRequests(state)[id] || {
    pending: false,
    requestError: null
  }

const getInvitations = state => getState(state).invitations

const getInvitationsResult = createSelector(
  [getInvitations],
  invitations => (!invitations ? [] : invitations.result)
)

const getInvitationsMap = createSelector(
  [getInvitations],
  invitations => (!invitations ? {} : invitations.entities.invitations)
)

const getInvitationsList = createSelector(
  [getInvitationsResult, getInvitationsMap],
  (result, invitationsMap) => result.map(id => invitationsMap[id])
)

const getInvitation = (state, id) => getInvitationsMap(state)[id]

const getPagination = state => getState(state).pagination

export {
  getInvitations,
  getInvitationsList,
  getFetchInvitationsRequest,
  getInvitation,
  getRemoveInvitationRequest,
  getPagination
}
